import { alpha } from "@mui/material/styles";
import { FONT_CHU, FONT_HIEU, MAU, RADIUS, SEMANTIC, SPACE } from "assets/theme/avocadoBrand";

export const oInputAuth = {
  "& .MuiOutlinedInput-root": {
    borderRadius: `${RADIUS.input}px`,
    backgroundColor: SEMANTIC.surface,
    fontFamily: FONT_CHU,
    "& fieldset": { borderColor: alpha(MAU.skin, 0.22) },
    "&:hover fieldset": { borderColor: alpha(MAU.skin, 0.5) },
    "&.Mui-focused fieldset": { borderColor: MAU.pit, borderWidth: "2px" },
  },
  "& .MuiOutlinedInput-input": { padding: `${SPACE[3]}px ${SPACE[4]}px` },
};

/** Bổ sung cho MDButton variant="gradient" color="info" — không !important màu. */
export const sxNutAuth = {
  py: 1.5,
  borderRadius: `${RADIUS.button}px`,
  fontFamily: FONT_HIEU,
  fontWeight: 600,
  fontSize: "1rem",
  textTransform: "none",
  "&:focus-visible": {
    outline: `3px solid ${alpha(MAU.pit, 0.6)}`,
    outlineOffset: "2px",
  },
};
